import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { GlobalSpinnerService } from '../../../shared/components/loader-service/global-spinner.service';
import { Principal } from '../../../shared/auth/principal.service';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { BridgeAdUnit } from '../../../shared/domain/bridge-ad-unit.model';
import { AdStatsBridgeAdUnitsService } from '../../../shared/services/ad-stats-bridge-ad-units.service';
import { Publisher } from '../../../shared/domain/publisher.model';

@Component({
  selector: 'cm-publisher-unit-notes-dialog',
  templateUrl: './publisher-unit-notes-dialog.component.html'
})
export class PublisherUnitNotesDialogComponent implements OnInit {

  adUnit: BridgeAdUnit;
  publisher: Publisher;

  constructor(public dialogRef: MatDialogRef<PublisherUnitNotesDialogComponent>,
              private gss: GlobalSpinnerService,
              private principal: Principal,
              private service: AdStatsBridgeAdUnitsService,
              private sbs: SnackBarService,
              private matDialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.adUnit = data.adUnit;
    if (data.adUnit) {
      this.publisher = data.adUnit.publisher;
    } else {
      this.publisher = data.publisher;
    }
  }

  ngOnInit(): void {
  }


}
